import ConnectAPI from "../../../services/api";
import React, { useState, useEffect } from "react";
import { Table, Tabs, Modal, Button, TextBox, TextArea, Select } from "@veneer/core";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import $ from 'jquery';
import { Col, Container, Row } from "react-bootstrap";

function SpecialConditionsProcess(props) {

    const connectApi = new ConnectAPI();
    const [tableData, setTableData] = useState([]);
    const [dataSCPPending, setDataSCPPending] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const { t } = useTranslation();
    const [activeTabIndex, setactiveTabIndex] = useState(0);
    const [activeTabIndexRender, setactiveTabIndexRender] = useState(0);
    const [item, setItem] = useState({});
    const [showModal, setShowModal] = useState(false);
    
    const selectTab = (event) => (index) => {
        setactiveTabIndex(index);
    };

    useEffect(() => {
        //validate location
        /*
        let currentUser = JSON.parse(localStorage.getItem("currentUser"));
        let validate = false;
        currentUser.urls.forEach( ur => {
            if ( ur == window.location.pathname ) validate=true;
        });
        if (validate==false){
            const { history } = props;
            history.push({ pathname: '/' });
        }//end validate
 */     
        const fetchData = () => {
            connectApi.get( "api/Channels/GetSCProcess", '', getSCProcessRespond ).catch(
                (error) => {
                    setIsLoading(false);
                    Swal.fire( "Error " + error?.response?.status, error?.response?.data, "error" );
                }
            );
        };
        const getSCProcessRespond = (status, data) => {
            setTableData(data);
            setDataSCPPending(data.filter(x => x.status == 'Pending'));
            setIsLoading(false);
        };

        fetchData();
    }, []);

    function viewParametersModal(e){
        var idRequest = $(e.target).closest('tr').children().eq(0).text();
        var customerName = $(e.target).closest('tr').children().eq(2).text();
        if( idRequest !== "ID Process" && idRequest !== '' && customerName !== t('customerName') ){
            let scpItem = tableData.find(scp => scp.idRequest == idRequest && scp.customerName == customerName);
            if ( scpItem.idRequest !== null || scpItem.customerName !== null ){
                console.log("-----------------------------------MODAL VIEW----------------------------------------------")
                console.log(scpItem)
                setItem(scpItem);
                setShowModal(true);
            }
        }
    };
    
    const [orderBy, setOrderBy] = useState(t('idRequest'));
    const [orderType, setOrderType] = useState("descending");
    const handleSort = (_, { id, type }) => { setOrderBy(id); setOrderType(type); };

    const RenderReportProcess = () => {
        const [pageSize] = useState(10);
        const [pages, setPages] = useState({ pending: 1, approved: 1, rejected: 1, });
        const handlePageChange = (tabKey) => (page) => {
            setPages( prev => ({ ...prev, [tabKey]: page }) );
        };
        const selectTabRender = (event) => (index) => {
            setactiveTabIndexRender(index);
        };

        function RenderProcessTab({
            data,
            currentPage,
            onPageChange,
            t,
            orderBy,
            orderType,
            pageSize,
            totalItems
        }) {
            return (
                <>
                    <Table
                        onClick = {viewParametersModal}
                        columns={[
                            { id: 'idRequest', label: "ID Process" },
                            { id: 'category', label: "Categoria de Solicitud" },
                            { id: 'customerName', label: t('customerName') },
                            { id: 'endUserName', label: t('endUserName') },
                            { id: 'specialConditionType', label: t('Special Condition Type') },
                            //{ id: 'specialConditionType2', label: "Segmento:" },
                            //{ id: 'specialConditionType5', label: "Modelo de Prensa" },
                            //{ id: 'specialConditionType4', label: "Numero de Serie" },
                            //{ id: 'specialConditionType4', label: "Edad de la Prensa" },
                            { id: 'startDate', label: t('specialcondition.startdate') },
                            { id: 'endDate', label: t('specialcondition.enddate') },
                            { id: 'contatName', label: "Nombre del Solicitante" },
                            //{ id: 'specialConditionType3', label: "Revisado por (GTM - HP Indigo)" },
                        ]}
                        data={data}
                        loading={isLoading}
                        showFilters
                        onSort={(e, { id, type }) => {
                            handleSort(e, { id, type });
                        }}
                        preferences={{
                            sortBy: { id: orderBy, type: orderType }
                        }}
                        pagination={{
                            currentPage,
                            onPageChange,
                            pageSize,
                            totalItems
                        }}
                    />
                </>
            );
        }
    
        const tabsConfig = [{
                id: 0,
                label: t('Pending'),
                data: tableData.filter(x => x.status == 'Pending'),
                currentPage: pages.pending,
                onPageChange: handlePageChange('pending')
            },{
                id: 1,
                label: t('approve'),
                data: tableData.filter(x => x.status == 'Approved'),
                currentPage: pages.approved,
                onPageChange: handlePageChange('approved')
            },{
                id: 3,
                label: t("reject"),
                data: tableData.filter(x => x.status == 'Rejected'),
                currentPage: pages.rejected,
                onPageChange: handlePageChange('rejected'),
            }
        ];
        let listRender = tabsConfig.map(tab => ({
            id: tab.id,
            label: tab.label,
            content: (
                <div style={{ padding: '30px' }}>
                    <RenderProcessTab
                        data={tab.data}
                        currentPage={tab.currentPage}
                        onPageChange={tab.onPageChange}
                        t={t}
                        orderBy={orderBy}
                        orderType={orderType}
                        pageSize={pageSize}
                        totalItems={1}
                    />
                </div>
            )
        }));
        return(<>
            <br />
            <Tabs
                controlId="default"
                onChangeTab={selectTabRender()}
                selectedTabId={activeTabIndexRender}
                tabs={listRender}
            />
            <Modal
                id="regular-modal"
                onClose={() => setShowModal(false)}
                show={showModal}
                title={t('scDetails')}
                footer={(
                <div className="vn-button-group--responsive">
                    <Button appearance="secondary" onClick={() => setShowModal(false)}>Close</Button>
                </div>
                )}
            >
                <div>
                    <p> Categoria de Solicitud: {item.category} </p>
                    <p> {t('customerName')}: {item.customerName} </p>
                    <p> {t('endUserName')}: {item.endUserName} </p>
                    <p> {t('segment')}: ---- </p>
                    <p> Modelo de Prensa: ---- </p>
                    <p> Edad de la Prensa: ---- </p>
                    <p> Serie: {item.serie} </p>
                    <p> Modelo de Negocio: ---- </p>
                    <p> {t('Special Condition Type')}: {item.specialConditionType} </p>
                    <p> {t('specialcondition.startdate')}: {item.startDate} </p>
                    <p> {t('effMonth')}: {item.effectiveMonths} </p>
                    <p> {t('specialcondition.enddate')}: {item.endDate} </p>
                    <p> {t('scDetails')}: {item.details} </p>
                    <p> Impresiones promedio Mensuales: ---- </p>
                    {item.category == 'Ramp up' ? (<>
                        <p> {t('Business Information')}: {item.ovjetive} </p>
                        <p> {t('Business Justification')}: {item.justification} </p>
                        <p> {t('Competition')}: {item.competition} </p>
                        <p> Resultado esperado: {item.resultFuture} </p>
                    </>):(<></>)}
                    <p> Condicion Especial previa: ---- </p>
                    <p> Condiciones Especiaes previas (2 años atras): ---- </p>
                    <p> {t('contactName')}: {item.contactName} </p>
                    <p> Revisado por: ---- </p>
                </div>
            </Modal>
        </>);
    }
    let itemSCP = undefined;
    const ApproverProces = () => {
        
        const [itemPending, setItemPending] = useState({});
        const [selectItem, setSelectItem] = useState(false);
        const [analisys, setAnalisys] = useState(false);
        const [montsReview, setMontsReview] = useState(0);
        const [multiplierAffected, setMultiplierAffected] = useState(0);

        function viewParametersPending(e){
            var idRequest = $(e.target).closest('tr').children().eq(0).text();
            var customerName = $(e.target).closest('tr').children().eq(2).text();
            if( idRequest !== "ID Process" && idRequest !== '' && customerName !== t('customerName') ){
                let scpItem = dataSCPPending.find(scp => scp.idRequest == idRequest && scp.customerName == customerName);
                if ( scpItem.idRequest !== null || scpItem.customerName !== null ){
                    console.log("-----------------------------------????????????????????----------------------------------------------")
                    console.log(scpItem)
                    itemSCP = scpItem;
                    setItemPending(scpItem);
                    setSelectItem(true);
                }
            }
        };

        return (<>
            <br /><br /> <h5 style={{marginBottom: "12px"}}>{"Vista de Aprovaciones / Análisis"}</h5>
            <Table 
                id='SCP-pendingReview'
                onClick={viewParametersPending}
                columns={ [
                    { id: 'idRequest', label: 'ID Process', }, 
                    { id: 'category', label: 'Categoria de Solicitud', }, 
                    { id: 'customerName', label: t('channels'), }, 
                    { id: 'endUserName', label: t('endUserName'), }, 
                    { id: 'specialConditionType', label: t('Special Condition Type'), }, 
                    { id: 'startDate', label: t('specialcondition.startdate'), }, 
                    { id: 'endDate', label: t('specialcondition.enddate'), }, 
                    { id: 'contatName', label: 'Nombre del Solicitante', }
                ]}
                data={dataSCPPending}
                loading={isLoading}
                showFilters
                onSort={(e, { id, type }) => { handleSort(e, { id, type }); }}
                preferences={{ sortBy: { id: orderBy, type: orderType } }}
            />
            {selectItem?(<>
                {analisys?(<>
                    <br /><br /> <h5 style={{marginBottom: "12px"}}>{"Vista de Análisis"}</h5>
                    <br /><div className="vn-button-group--responsive">
                        
                        <Container style={{margin: "10px 0"}}>
                            <Row>
                                <Col xs="4" md="4">
                                    <Select
                                        id="months-review"
                                        label="Months Analysis Review"
                                        options={[
                                            { value: 3, label: '3 Months' },
                                            { value: 6, label: '6 Months' },
                                            { value: 12, label: '12 Months' },
                                        ]}
                                        value={[montsReview]}
                                        onChange={(e) => { setMontsReview(e.value); }}
                                        clearIcon={false}
                                    />
                                </Col>
                                <Col xs="4" md="4">
                                    <TextBox
                                        id="multiple-affected"
                                        label="PPI Multiple Affected"
                                        value={multiplierAffected}
                                        maxLength="10"
                                        onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                                        onchange={(e) => { if(!isNaN(e)) setMultiplierAffected(e); }}
                                    />
                                </Col>
                            </Row>
                            <Row style={{marginTop: "20px"}}>
                                <Col xs="4" md="4">
                                    <TextBox
                                        id="preview1"
                                        label="impresiones totales del Mes: MMMM YYYY"
                                        disabled
                                    />
                                </Col>
                                <Col xs="4" md="4">
                                    <TextBox
                                        id="preview12"
                                        label="Total del Bono para el Mes: MMMM YYYY"
                                        disabled
                                    />
                                </Col>
                                <Col xs="4" md="4">
                                    <TextBox
                                        id="preview13"
                                        label="Total de la compensacion para el Mes: MMMM YYYY"
                                        disabled
                                    />
                                </Col>
                            </Row>
                            <Row style={{marginTop: "20px"}}>
                                <h5> Crecimiento esperado para los siguientes: {montsReview} meses </h5>
                                <div class="chart-container">
                                    <canvas id="chartCanvas"></canvas>
                                </div>
                            </Row>
                            <Row style={{marginTop: "20px"}}>
                                <Col xs="4" md="4">
                                    <TextBox
                                        id="idCategory"
                                        value={itemSCP.category}
                                        label={t('category')}
                                        readOnly
                                    />
                                </Col>
                                <Col xs="4" md="4">
                                    <TextBox
                                        id="idChannel"
                                        value={itemSCP.customerName}
                                        label={t('channel')}
                                        readOnly
                                    />
                                </Col>
                                <Col xs="4" md="4">
                                    <TextBox
                                        id="idOpdNumber"
                                        value={itemSCP.opd}
                                        label="OPD #"
                                        readOnly
                                    />
                                </Col>
                            </Row>
                            <Row style={{marginTop: "20px"}}>
                                <Col xs="4" md="4">
                                    <TextBox
                                        id="idEnduser"
                                        value={itemSCP.endUserName}
                                        label={t('endUserName')}
                                        readOnly
                                    />
                                </Col>
                                <Col xs="4" md="4">
                                    <TextBox
                                        id="idSerie"
                                        value={itemSCP.serie}
                                        label={t("series")}
                                        readOnly
                                    />
                                </Col>
                            </Row>
                            <Row style={{marginTop: "20px"}}>
                                <Col xs="12" md="12">
                                    <Table
                                        name="press-table"
                                        columns={[ 
                                            { id: "uid", index:"hidden" },
                                            { id: "idPress", label: t('press id') }, 
                                            { id: "classification", label: t('classification') }, 
                                            { id: "installDate", label: t('InstallDate') }, 
                                            { id: "dateEndUser", label: t('DateEndUser') },
                                            { id: "segments", label: t('sgmento') },
                                        ]}
                                        data={[]} 
                                    />
                                </Col>
                            </Row>
                            <Row style={{marginTop: "20px"}}>
                                <Col xs="4" md="4">
                                    <TextBox
                                        id="idStartDate"
                                        value={itemSCP.startDate}
                                        label={t("startdate")}
                                        readOnly
                                    />
                                </Col>
                                <Col xs="4" md="4">
                                    <TextBox
                                        id="idEffectiveMonth"
                                        value={itemSCP.effectiveMonths}
                                        label={t('effMonth')}
                                        readOnly
                                    />
                                </Col>
                                <Col xs="4" md="4">
                                    <TextBox
                                        id="idEndDate"
                                        value={itemSCP.endDate}
                                        label={t('specialcondition.enddate')}
                                        readOnly
                                    />
                                </Col>
                            </Row>
                        </Container>

                        <Button appearance="primary" onClick={() => setAnalisys(false)}>Back</Button>
                    </div>
                </>):(<>
                    <br /><br /> <h5 style={{marginBottom: "12px"}}>{"Vista de Aprovaciones"}</h5>

                    <Container style={{margin: "10px 0"}}>
                        <h4 style={{marginBottom: "12px"}}>{t('End User and Press Information')}</h4>
                        <Row>
                            <Col xs="4" md="4">
                                <TextBox
                                    id="idCategory"
                                    value={itemSCP.category}
                                    label={t('category')}
                                    readOnly
                                />
                            </Col>
                            <Col xs="4" md="4">
                                <TextBox
                                    id="idChannel"
                                    value={itemSCP.customerName}
                                    label={t('channel')}
                                    readOnly
                                />
                            </Col>
                            <Col xs="4" md="4">
                                <TextBox
                                    id="idOpdNumber"
                                    value={itemSCP.opd}
                                    label="OPD #"
                                    readOnly
                                />
                            </Col>
                        </Row>
                        <Row style={{marginTop: "20px"}}>
                            <Col xs="4" md="4">
                                <TextBox
                                    id="idEnduser"
                                    value={itemSCP.endUserName}
                                    label={t('endUserName')}
                                    readOnly
                                />
                            </Col>
                            <Col xs="4" md="4">
                                <TextBox
                                    id="idSegment"
                                    label={t('segmento')}
                                    readOnly
                                />
                            </Col>
                            <Col xs="4" md="4">
                                <TextBox
                                    id="idSerie"
                                    value={itemSCP.serie}
                                    label={t("series")}
                                    readOnly
                                />
                            </Col>
                        </Row>
                        <Row style={{marginTop: "20px"}}>
                            <Col xs="12" md="12">
                                <Table
                                    name="press-table"
                                    columns={[ 
                                        { id: "uid", index:"hidden" },
                                        { id: "idPress", label: t('press id') }, 
                                        { id: "classification", label: t('classification') }, 
                                        { id: "installDate", label: t('InstallDate') }, 
                                        { id: "dateEndUser", label: t('DateEndUser') }, 
                                        { id: "program",  label: t('Program') }
                                    ]}
                                    data={[]} 
                                />
                            </Col>
                        </Row>
                        <Row style={{marginTop: "20px"}}>
                            <Col xs="4" md="4">
                                <TextBox
                                    id="idStartDate"
                                    value={itemSCP.startDate}
                                    label={t("startdate")}
                                    readOnly
                                />
                            </Col>
                            <Col xs="4" md="4">
                                <TextBox
                                    id="idEffectiveMonth"
                                    value={itemSCP.effectiveMonths}
                                    label={t('effMonth')}
                                    readOnly
                                />
                            </Col>
                            <Col xs="4" md="4">
                                <TextBox
                                    id="idEndDate"
                                    value={itemSCP.endDate}
                                    label={t('specialcondition.enddate')}
                                    readOnly
                                />
                            </Col>
                        </Row>
                        <Row style={{marginTop: "20px"}}>
                            <Col xs="12" md="12">
                                <TextArea
                                    id="detalle-id"
                                    value={itemSCP.details}
                                    label={t('Detalle de la condicion solicitada')}
                                    readOnly
                                /><br />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs="4" md="4">
                                <TextBox
                                    id="objetivo-id"
                                    value={itemSCP.ovjetive}
                                    label={t('Objetivo')}
                                    readOnly
                                /><br />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs="12" md="12">
                                <TextArea
                                    id="justification-id"
                                    value={itemSCP.justification}
                                    label={t('Justificacion')}
                                    readOnly
                                /><br />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs="4" md="4">
                                <TextBox
                                    id="volumeG-id"
                                    value={itemSCP.volumeGrowth}
                                    label={t('Volume Growth')}
                                    readOnly
                                /><br />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs="12" md="12">
                                <TextArea
                                    id="competition-id"
                                    value={itemSCP.competition}
                                    label={t('Competencia')}
                                    readOnly
                                /><br />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs="12" md="12">
                                <TextArea
                                    id="resultado-id"
                                    value={itemSCP.resultFuture}
                                    label={t('Resultado esperado con la condicion')}
                                    readOnly
                                /><br />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs="12" md="12">
                                <TextArea
                                    id="comentarios-id"
                                    value={itemSCP.comments}
                                    label={t('comments')}
                                    readOnly
                                /><br />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs="4" md="4">
                                <TextBox
                                    id="contact-name"
                                    value={itemSCP.contatName}
                                    label={t('contactName')}
                                    readOnly
                                />
                            </Col>
                            <Col xs="4" md="4">
                                <TextBox
                                    id="idCreateBy"
                                    value={itemSCP.createBy}
                                    label="Revisado por:"
                                    readOnly
                                />
                            </Col>
                            <Col xs="4" md="4">
                                <TextBox
                                    id="idStatus"
                                    value={itemSCP.status}
                                    label={t('Status')}
                                    readOnly
                                /><br />
                            </Col>
                        </Row>
                    </Container>

                    <br /><div className="vn-button-group--responsive">
                        <Button appearance="warning" >Request Modify</Button>
                        <Button appearance="success" >Approved</Button>
                        <Button appearance="secondary" onClick={() => {setItemPending({}); setSelectItem(false);}}>Cancel</Button>
                        <Button appearance="primary" onClick={() => setAnalisys(true)}>Analysis</Button>
                    </div>
                </>)}
            </>):(<> </>)}
        </>)
    }

    let list = [
        { id: 0, label: "Reporte de Solicitudes", content: <div><RenderReportProcess/></div>},
        { id: 1, label: "Análisis", content: <div><ApproverProces/></div>},
    ];

    return(<>
        <Tabs
            controlId="default"
            onChangeTab={selectTab()}
            selectedTabId={activeTabIndex}
            tabs={list}
        />
    </>);
}

export default SpecialConditionsProcess;